import { templatesQuery } from "@commerce/channels/queries";
import { templatesSearchSchema } from "@commerce/channels/search-params";
import {
	TemplatesScreen,
	TemplatesSkeleton,
} from "@commerce/channels/TemplatesTab";
import { Page } from "@commerce/components/page";
import { isOrganizationAdmin } from "@repo/auth/lib/helper";
import { config } from "@repo/config";
import { AdminOnlyNotice } from "@saas/settings/components/SettingsLayout";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/channels/templates",
)({
	validateSearch: templatesSearchSchema,
	beforeLoad: ({ context }) => ({
		isOrganizationAdmin: isOrganizationAdmin(
			context.organization,
			context.session.user,
		),
	}),
	shouldReload: false,
	loader: async ({ context }) => {
		const organizationId = context.organization.id;
		const queryClient = getServerQueryClient();
		if (context.isOrganizationAdmin) {
			await queryClient.ensureQueryData(templatesQuery(organizationId));
		}
		return {
			organizationId,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({
		meta: [{ title: `WhatsApp templates - ${config.appName}` }],
	}),
	component: TemplatesPage,
});

function TemplatesPage() {
	const { isOrganizationAdmin } = Route.useRouteContext();
	const { organizationId, dehydratedState } = Route.useLoaderData();
	if (!isOrganizationAdmin) {
		return (
			<Page width="narrow">
				<AdminOnlyNotice what="templates" />
			</Page>
		);
	}
	return (
		<AsyncBoundary
			fallback={<TemplatesSkeleton />}
			dehydratedState={dehydratedState}
			errorFallback="inline"
		>
			<TemplatesScreen organizationId={organizationId} />
		</AsyncBoundary>
	);
}
